<template>
  <div class="row mt-3">
    <div class="border-bottom mb-3">
      <h5 class="text-muted fw-light">
        <i class="ri-award-line"></i>
        Descripción Arrendamiento
      </h5>
    </div>
    <div class="form-group col-md-3">
      <label>Plazo*</label>
      <select name="plazo" id="plazo" class="form-control" required>
        <option value="">Seleccione</option>
        <option value="12 MESES">12 MESES</option>
        <option value="24 MESES">24 MESES</option>
        <option value="36 MESES">36 MESES</option>
        <option value="48 MESES">48 MESES</option>
        <option value="60 MESES">60 MESES</option>
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Pago inicial*</label
      ><input
        type="tel"
        class="form-control"
        name="pago_inicial"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Fecha pago inicial*</label
      ><input
        type="date"
        class="form-control"
        name="fecha_pago_inicial"
        required=""
        autocomplete="off"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Renta mensual*</label
      ><input
        type="tel"
        class="form-control"
        name="renta_mensual"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Fecha pago*</label
      ><input
        type="date"
        class="form-control"
        name="fecha_pago"
        required=""
        autocomplete="off"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Gastos investigación*</label
      ><input
        type="tel"
        class="form-control"
        name="gastos_investigacion"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Valor residual*</label
      ><input
        type="tel"
        class="form-control"
        name="valor_residual"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Comisión por apertura*</label
      ><input
        type="tel"
        class="form-control"
        name="comision_apertura"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Interés moratorio*</label
      ><input
        type="tel"
        class="form-control"
        name="interes_moratorio"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Tipo de renta*</label
      ><select name="tipo_renta" class="form-control" required>
        <option value="">Seleccione</option>
        <option value="MENSUAL">MENSUAL</option>
        <option value="BIMESTRAL">BIMESTRAL</option>
        <option value="TRIMESTRAL">TRIMESTRAL</option>
        <option value="SEMESTRAL">SEMESTRAL</option>
        <option value="ANUAL">ANUAL</option>
      </select>
    </div>
    <div class="form-group col-md-6">
      <label>Seguro*</label
      ><input
        type="text"
        class="form-control"
        name="seguro"
        required=""
        autocomplete="off"
      />
    </div>
  </div>
</template>

<script>
import useContratosStore from "@/store/contratos";
import { useGeneralStore } from "@/store/general";
import { storeToRefs } from "pinia";

export default {
  setup() {
    const { validateDecimal } = useGeneralStore();
    const contratosStore = useContratosStore();

    const { fetchClientes } = contratosStore;

    const { loadingClientes, cliente, clientes } = storeToRefs(contratosStore);

    fetchClientes();

    return {
      clientes,
      loadingClientes,
      cliente,
      validateDecimal,
    };
  },
};
</script>

<style></style>
